import { Component, OnInit, Output, EventEmitter, OnDestroy, Input } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { SIDEBARLINKS } from "../../constants/sideBarLinks";
import { PermissionUrlService } from "./../../../shared/services/permissions.service";
import { LocalStorageService } from "./../../../shared/services/local-storage.service";
import { SettingsConstant } from "./../../../shared/constants/settings.constants";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginService } from "../../services/login.service"
@Component({
  selector: "sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"]
})
export class SidebarComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Output() navlinkclick = new EventEmitter();
  @Input() userProfile = null
  currentRoute: any = document.location.href;
  routes: Array<Object> = [];
  userProfileAvatar: any;
  userProfie: any = {};
  user: any;
  userFirstName;
  userLastName;
  public avatarBackgroundcolor;
  currentClient;
  clientDetails;
  //   jwtHelper = new JwtHelper();
  //   checkOR = this.jwtHelper.decodeToken(this.localStorage.getItem(SettingsConstant.LOCALSTORAGE_KEYS.ID_TOKEN))["http://delhivery.com/user_type"]
  //   showUMS = this.jwtHelper.decodeToken(this.localStorage.getItem(SettingsConstant.LOCALSTORAGE_KEYS.ID_TOKEN))['http://delhivery.com/is_client_admin']
  //   godam_token =  this.jwtHelper.decodeToken(this.localStorage.getItem(SettingsConstant.LOCALSTORAGE_KEYS.TELESCOPE_TOKEN))['scope']

  userDetail = this.localStorage.getItem(
    SettingsConstant.LOCALSTORAGE_KEYS.USER_DETAILS
  );
  userScopes = this.localStorage.getItem(
    SettingsConstant.LOCALSTORAGE_KEYS.USER_SCOPES
  );

  sideBarInfo = SIDEBARLINKS.map(el => {
    //  // el['route'] == "/user-management" ? el['show'] = this.showUMS : true
    if (el['route'] == "/user-management" && this.userDetail.user_type == 'OR' && this.userScopes.includes('telescope-ums')) {
      el['show'] = true;
    }
    return el
  });

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private loginService: LoginService,
    private widgetPermissions: PermissionUrlService,
    private localStorage: LocalStorageService,
  ) {

    this.userProfie = this.localStorage.getItem(
      SettingsConstant.LOCALSTORAGE_KEYS.USER_DETAILS
    );

    this.clientDetails = this.localStorage.getItem(
      SettingsConstant.LOCALSTORAGE_KEYS.CLIENT_LIST
    );
    if (this.clientDetails) {
      this.clientDetails = JSON.parse(this.clientDetails).map((data) => {
        data["client_name"] = data["meta_data"] && data["meta_data"]["name"] ? data["meta_data"]["name"] : "Unknown";
        return data;
      });
    }
    this.currentClient = this.localStorage.getItem(SettingsConstant.LOCALSTORAGE_KEYS.SELECTED_CLIENT);

    this.routeEvent(this.router);
  }

  ngOnInit() {
    this.router.events.pipe(takeUntil(this.unsubscribe)).subscribe(data => {
      this.currentRoute = data["url"];
    });
  }

  routeEvent(router: Router) {
    router.events.pipe(takeUntil(this.unsubscribe)).subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.navlinkclick.emit();
      }
    });
  }

  changeCurrentClient() {
    this.localStorage.setItem(
      SettingsConstant.LOCALSTORAGE_KEYS.SELECTED_CLIENT, this.currentClient
    );
    if (location.href.indexOf("?") > -1) {
      location.href = location.href.substr(0, location.href.indexOf("?"));
    }
    location.reload();

  }

  logOut(): void {
    // 666
    this.loginService.logOut();
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
